import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { ProgramCompaniesTab } from '../tabs/ProgramCompaniesTab';
export function CompaniesPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(ProgramCompaniesTab, {
            programId: programId
        })
    });
}
